// ============================================
// Prenta — API Client
// ============================================

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:8787';

async function request(path, options = {}) {
  const { method = 'GET', body, token } = options;

  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Villa kom upp');
  return data;
}

async function uploadFile(file, token) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(`${API_BASE}/api/files`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Villa við upphal');
  return data;
}

// ============================================
// Auth
// ============================================
export const auth = {
  sync: (token) => request('/api/auth/sync', { method: 'POST', token }),
  me: (token) => request('/api/auth/me', { token }),
};

// ============================================
// Makers
// ============================================
export const makers = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/api/makers${qs ? `?${qs}` : ''}`);
  },
  get: (id) => request(`/api/makers/${id}`),
  register: (body, token) => request('/api/makers', { method: 'POST', body, token }),
  update: (id, body, token) => request(`/api/makers/${id}`, { method: 'PUT', body, token }),
};

// ============================================
// Services
// ============================================
export const services = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/api/services${qs ? `?${qs}` : ''}`);
  },
  create: (body, token) => request('/api/services', { method: 'POST', body, token }),
  update: (id, body, token) => request(`/api/services/${id}`, { method: 'PUT', body, token }),
  remove: (id, token) => request(`/api/services/${id}`, { method: 'DELETE', token }),
};

// ============================================
// Requests
// ============================================
export const requests = {
  list: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/api/requests${qs ? `?${qs}` : ''}`);
  },
  get: (id) => request(`/api/requests/${id}`),
  create: (body, token) => request('/api/requests', { method: 'POST', body, token }),
  update: (id, body, token) => request(`/api/requests/${id}`, { method: 'PUT', body, token }),
};

// ============================================
// Quotes
// ============================================
export const quotes = {
  list: (requestId) => request(`/api/quotes?request_id=${requestId}`),
  send: (body, token) => request('/api/quotes', { method: 'POST', body, token }),
  respond: (id, body, token) => request(`/api/quotes/${id}`, { method: 'PUT', body, token }),
};

// ============================================
// Orders
// ============================================
export const orders = {
  list: (params = {}, token) => {
    const qs = new URLSearchParams(params).toString();
    return request(`/api/orders${qs ? `?${qs}` : ''}`, { token });
  },
  get: (id, token) => request(`/api/orders/${id}`, { token }),
  updateStatus: (id, body, token) => request(`/api/orders/${id}/status`, { method: 'PUT', body, token }),
};

// ============================================
// Reviews
// ============================================
export const reviews = {
  list: (makerId) => request(`/api/reviews?maker_id=${makerId}`),
  create: (body, token) => request('/api/reviews', { method: 'POST', body, token }),
};

// ============================================
// Messages
// ============================================
export const messages = {
  list: (requestId, token) => request(`/api/messages?request_id=${requestId}`, { token }),
  send: (body, token) => request('/api/messages', { method: 'POST', body, token }),
  markRead: (id, token) => request(`/api/messages/${id}/read`, { method: 'PUT', token }),
  unreadCount: (token) => request('/api/messages/unread-count', { token }),
};

// ============================================
// Files
// ============================================
export const files = {
  upload: uploadFile,
  url: (key) => `${API_BASE}/api/files/${key}`,
};
